<template>
    <div>
        <div class="maggiori-titolo"> Richiedi informazioni</div>
        <div class="maggiori-ag">
            <div class="form-group">
                <input type="text" name="name" class="form-control" :class="{ 'is-invalid' : $v.contattoInserzionista.name.$error }" v-model="contattoInserzionista.name" placeholder="Nome">
            </div>
            <div class="form-group">
                <input type="text" name="surname" class="form-control" :class="{ 'is-invalid' : $v.contattoInserzionista.surname.$error }" v-model="contattoInserzionista.surname" placeholder="Cognome">
            </div>
            <div class="form-group">
                <input type="email" name="email" class="form-control" :class="{ 'is-invalid' : $v.contattoInserzionista.email.$error }" v-model="contattoInserzionista.email" placeholder="Il tuo indirizzo email">
            </div>
            <div class="form-group">
                <input type="text" name="phone" class="form-control" :class="{ 'is-invalid' : $v.contattoInserzionista.phone.$error }" v-model="contattoInserzionista.phone" placeholder="Il tuo telefono">
            </div>
            <div class="form-group message">
                <textarea
                    class="form-control"
                    rows="2"
                    name="message"
                    id="message"
                    :class="{ 'is-invalid' : $v.contattoInserzionista.message.$error }"
                    v-model="contattoInserzionista.message"
                ></textarea>
            </div>
            <div class="form-group">
                <small>Questa form è protetta da reCAPTCHA e si applicano la <a href="https://policies.google.com/privacy">Privacy Policy</a> e le <a href="https://policies.google.com/terms">Condizioni di Servizio</a> di Google</small>
            </div>
            <div class="form-group">
                <label class="maggiori-r" :class="{ 'is-invalid' : $v.contattoInserzionista.privacy.$error }">
                    <input name="privacy" id="privacy" class="required" v-model="contattoInserzionista.privacy" type="checkbox" required>&nbsp;&nbsp;Acconsento al trattamento dei miei dati personali
                </label>
            </div>
            <div class="form-group mb-0">
                <div class="send-btn" data-gtm-event="richiesta-specifica-immobile" :data-immobile="immobile.id" :data-source="source">
                    <invisible-recaptcha type="button" v-if="captchakey" :sitekey="captchakey" :callback="submit" class="btn button-theme btn-md btn-block" :disabled="spedito" data-gtm-event="richiesta-specifica-immobile" :data-immobile="immobile.id" :data-source="source">
                        <i class="fas fa-spinner fa-spin" v-if="this.isSending"></i>
                        <span v-else data-gtm-event="richiesta-specifica-immobile" :data-immobile="immobile.id" :data-source="source">Conferma</span>
                    </invisible-recaptcha>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { validationMixin } from 'vuelidate';
    import {required, email} from 'vuelidate/lib/validators';
    import InvisibleRecaptcha from '../InvisibleRecaptcha.vue';

    export default {
        mixins: [validationMixin],
        props: ['immobile', 'sessionId', 'source'],
        components: {
            'invisible-recaptcha': InvisibleRecaptcha
        },
        validations: {
            contattoInserzionista: {
                name: { required },
                surname: { required },
                email: { required, email },
                message: { required},
                phone: { required},
                privacy : { checked: value => value === true },
            }
        },
        data() {
            return {
                contattoInserzionista: {
                    name: null,
                    surname: null,
                    email: null,
                    phone: null,
                    message: null,
                    privacy: null,
                    session_id: this.sessionId ? this.sessionId : null,
                    tipo_annuncio: this.immobile.type ? this.immobile.type : 'STANDARD',
                    recaptcha: null
                },
                isSending: false,
                spedito: false,
                captchakey: process.env.MIX_RECAPTCHA
            };
        },
        methods: {
            submit(e) {
                this.$v.$touch();
                if(! this.$v.$invalid){
                    this.contattoInserzionista.recaptcha = e;
                    this.isSending = true;
                    window.axios.post(process.env.MIX_BASE_URL + 'forms/immobile/' + this.immobile.id + '/richiedi-info', this.contattoInserzionista)
                    .then(res => {
                        Swal.fire({
                            text: res.data.data.message,
                            type: 'success'
                        })
                        this.$emit('closemodal');
                        this.isSending = false;
                        this.spedito = true;
                    })
                    .catch(err => {
                        Swal.fire({
                            text: 'Ops! Qualcosa è andato storto, per favore prova di nuovo.',
                            type: 'error'
                        });
                        this.isSending = false;
                    });
                }
            },
            setMessage() {
                // Metto il titolo
                let string = this.immobile.title;
                // Aggiungo l'indirizzo se c'è
                if(this.immobile.address){
                    string = string + ', ' + this.immobile.address;
                }
                // Aggiungo il rif se c'è
                if(this.immobile.rif){
                    string = string + ' - ' + this.immobile.rif;
                }
                this.contattoInserzionista.message = 'Richiedo informazioni riguardo l\'immobile "' + string + '"';
            }
        },
        mounted() {
            this.setMessage();
        }
    }
</script>

<style lang="scss" scoped>
    .maggiori-r {
        &.is-invalid {
            color: #dc3545;
        }
    }
</style>
